import React from 'react';
import * as S from './InsuranceBlock.styles';
import { IINSURANCE_BLOCK, IINSURANCE_BLOCK_BENEFITS } from './../../../../containers/Review/Validation'
import { pushga } from 'ga-utils';
import { ReviewEvents } from './../../../../config/ga-config';

const InsuranceBlock = (props) => {
  if (props) {
    const { insuranceRequired, insuranceData, insuranceOption, onInsurnaceOptionSelect } = props;
    const { benifits, persuasion, title, url, insurance_logo, tc } = insuranceData as IINSURANCE_BLOCK;

    const requiredText = (bgClassName) => {
      return (<S.RequiredTxt>
        <S.RequiredTag className={bgClassName}>Required</S.RequiredTag>
        <span>Please select one of the above option</span>
      </S.RequiredTxt>);
    }

    return (
      <S.InsuranceWrap>
        <S.InsuranceTitle>
          <img src={insurance_logo} alt="insurance_logo" />
          <span style={{ paddingLeft: "1rem" }}>{title}</span>
        </S.InsuranceTitle>
        <S.InsuranceType>
          {benifits && benifits.length ? benifits.map(function (benefit: IINSURANCE_BLOCK_BENEFITS) {
            const { text, price, icon } = benefit;
            return (
              <S.InsTypeList key={text}>
                <img src={icon} alt="" style={{ maxHeight: "40px", maxWidth: "40px" }} />
                <S.InsTypeTxt>{text}</S.InsTypeTxt>
                <S.InsTypeTag>Upto ₹{price}</S.InsTypeTag>
              </S.InsTypeList>
            )
          }) : null}
        </S.InsuranceType>
        <S.CheckboxWrap>
          <S.RadioButton id="insuranceYes" htmlFor="insuranceYes" onClick={(evt) => {
            evt.preventDefault();
            onInsurnaceOptionSelect('yes');
          }}>
            <input type="radio" id="insuranceYes" name="insurance" value="insuranceYes" checked={(insuranceOption.value === "yes")} readOnly />
            <span className="checkmark"></span>
            <span className="radioLabel">Yes, secure my trip. I agree to the given</span>
            <span style={{ paddingLeft: "1rem", fontSize: "1.4rem", color: "#2276e3" }} onClick={(evt) => {
              evt.stopPropagation();
              pushga({
                event: ReviewEvents.actions.insurance_tc,
                eventCategory: ReviewEvents.category,
                eventAction: ReviewEvents.actions.insurance_tc,
              });
              window.open(tc)
            }}>Terms and Conditions</span>
            {insuranceOption.value === "yes" && insuranceOption.isLoading ? <S.TagLoader>
              <img src='https://gos3.ibcdn.com/circularloader-1591795611.gif' />
              <span>APPLYING</span>
            </S.TagLoader> : null}
          </S.RadioButton>
          <S.RadioButton id="insuranceNo" htmlFor="insuranceNo" onClick={(evt) => {
            evt.preventDefault();
            onInsurnaceOptionSelect('no');
          }}>
            <input type="radio" id="insuranceNo" name="insurance" value="insuranceNo" checked={(insuranceOption.value === "no")} readOnly />
            <span className="checkmark"></span>
            <span className="radioLabel">No, I am willing to risk my trip</span>
            {insuranceOption.value === "no" && insuranceOption.isLoading ? <S.TagLoader>
              <img src='https://gos3.ibcdn.com/circularloader-1591795611.gif' />
              <span>APPLYING</span>
            </S.TagLoader> : null}
          </S.RadioButton>
        </S.CheckboxWrap>
        {insuranceOption.err ?
          requiredText("bg-red") : requiredText("bg-blue")
        }
        {/* {persuasion ? <S.Persuation>{persuasion}</S.Persuation> : null} */}
      </S.InsuranceWrap>
    );
  } else {
    return null;
  }
}

export default InsuranceBlock;
